import React, { useState, useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import Swal from 'sweetalert2';
import NotifyC from '../../../components/Notifications';
import { useRequests } from '../../../hooks/useRequests';
import { useRemmitances } from "../../../hooks/useRemmitances";
import { useCash } from "../../../hooks/useCash";
import { useClient } from "../../../hooks/useClient";
import { FaClock } from "react-icons/fa6";
import { FaCheck, FaTimes, FaSyncAlt,FaInfoCircle} from "react-icons/fa";
import { BsSearch, BsBuilding, BsCalendar2Check, BsClock } from "react-icons/bs";
import { FaBan } from "react-icons/fa";
import { RiUserReceivedLine} from "react-icons/ri";
import { TbZoomReset } from "react-icons/tb";
import DataTable from "../../../components/ui/DataTable";
import { getUser, formatCurrency, sqlDateFormat, getStatusRequests, getActionName, getTypeRequestName } from "../../../utils/Common";
import Spinner from "../../../components/Spinner";
import DatePicker from "react-datepicker";
import SelectSearch from "../../../components/ui/SelectSearch";
import "react-datepicker/dist/react-datepicker.css";
import TimeRangePicker from 'rsuite/TimeRangePicker';
import CustomProvider  from 'rsuite/CustomProvider';
import * as locales from 'rsuite/locales';
import 'rsuite/TimeRangePicker/styles/index.css';
import './index.css'

const Solicitudes = () => {
    const user = getUser();
    const { getAllRequests, searchRequests, getListRequestsStatus, manageRequest, getListTypes} = useRequests();
    const { getListOffices } = useRemmitances();
    const { getCashBoxStatus } = useCash();
    const { getListClientByRole } = useClient();
    const { register, handleSubmit, reset, errors } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const [isRotating, setIsRotating] = useState(false);
    const [listOffice, setListOffice] = useState([]);
    const [officeSelected, setOfficeSelected] = useState("");

    const [listClients, setListClients] = useState([]);
    const [clientSelected, setClientSelected] = useState("");

    const [listCashBox, setListCashBox] = useState([]);
    const [cashBoxSelected, setCashBoxSelected] = useState("");

    const [allRequests, setAllRequests] = useState([]);
    const [searchedRequests, setSearchedRequests] = useState([]);

    const [listStatus, setListStatus] = useState([]);
    const [statusSelected, setStatusSelected] = useState("");

    const [listTypes, setListTypes] = useState([]);
    const [typeSelected, setTypeSelected] = useState("");

    const [creationDateRange, setCreationDateRange] = useState([null, null]);
    const [startCreationDate, endCreationDate] = creationDateRange;
    const [deliveryDateRange, setDeliveryDateRange] = useState([null, null]);
    const [startDeliveryDate, endDeliveryDate] = deliveryDateRange;
    const [timeCreation, setTimeCreation] = useState([]);
    const [startCreationTime, endCreationTime] = timeCreation;
    const [timeAprobation, setTimeAprobation] = useState([]);
    const [startAprobationTime, endAprobationTime] = timeAprobation;
    const data = Object.keys(locales).map(key => ({
        key: key.replace(/([a-z]{2})([A-Z]{2})/, '$1-$2'),
        value: locales[key]
        }));
    const [localeKey, setLocaleKey] = useState('es-ES');
    const locale = data.find(item => item.key === localeKey);

    const [actionButtons, setActionButtons] = useState([
        {
            icon: <FaCheck color="green" />,
            label: "Aprobar",
            action: (row) => {
                Swal.fire({
                    title: "¿Está seguro de que desea aprobar la solicitud?",
                    text: `ID Solicitud: ${row.IdSolicitud} - ${row.NombreSolicitante}`,
                    icon: "warning",
                    showCancelButton: true,
                    showDenyButton: row.IdTipoSolicitud === 1 && row.Accion === 3, // Solo mostrar "Editar" si el tipo es 1
                    confirmButtonText: "Aprobar",
                    denyButtonText: "Editar",
                    cancelButtonText: "Cancelar",
                    customClass: {
                        confirmButton: "custom-confirm-button",
                        cancelButton: "custom-cancel-button",
                        denyButton: "custom-confirm-button",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleConfirmAction(2, row);
                    } else if (result.isDenied && row.IdTipoSolicitud === 1) {
                        Swal.fire({
                            title: `Editar solicitud ${row.IdSolicitud}`,
                            html: `
                                <p><strong>Solicitante:</strong> ${row.NombreSolicitante}</p>
                                <p><strong>Saldo actual:</strong> ${formatCurrency(row.SaldoIngresado)}</p>
                                <input id="newSaldo" type="number" class="swal2-input" placeholder="Ingrese el nuevo saldo" value="${row.SaldoIngresado}" />
                            `,
                            icon: "info",
                            confirmButtonText: "Guardar cambios",
                            cancelButtonText: "Cancelar",
                            showCancelButton: true,
                            preConfirm: () => {
                                const newSaldo = document.getElementById('newSaldo').value;
                                if (!newSaldo || isNaN(newSaldo) || newSaldo <= 0) {
                                    Swal.showValidationMessage("Por favor, ingrese un saldo válido.");
                                    return false;
                                }
                                return newSaldo;
                            },
                        }).then((editResult) => {
                            if (editResult.isConfirmed) {
                                const updatedSaldo = editResult.value;
                                handleConfirmAction(2, row, updatedSaldo);
                                NotifyC.success("Cambios guardados", "success");
                            }
                        });
                    }
                });
            },
        },
        {
            icon: <FaTimes color='red'/>,
            label: "Rechazar",
            action: (row) => {
                Swal.fire({
                    title: "¿Está seguro de que desea rechazar la solicitud?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Rechazar",
                    cancelButtonText: "Cancelar",
                    customClass: {
                        confirmButton: "custom-confirm-button",
                        cancelButton: "custom-cancel-button",
                        denyButton: "custom-confirm-button",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                         handleConfirmAction(3, row);
                        NotifyC.error("Solicitud rechazada", "error");
                    }
                });
            },
        },  
        {
            icon: <FaBan />,
            label: "Cancelar",
            action: (row) => {
                Swal.fire({
                    title: "¿Está seguro de que desea cancelar la solicitud?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Continuar",
                    cancelButtonText: "Cancelar",
                    customClass: {
                        confirmButton: "custom-confirm-button",
                        cancelButton: "custom-cancel-button",
                        denyButton: "custom-confirm-button",
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleConfirmAction(4, row);
                        NotifyC.error("Solicitud cancelada", "error");
                    }
                });
            },
        },
        {
            icon: <FaInfoCircle color="blue" />,
            label: "Detalles",
            action: (row) => {
                Swal.fire({
                    title: `<span style="font-size: 1.5em; color: #2c3e50;">Solicitud #${row.IdSolicitud}</span>`,
                    html: `
                        <div style="text-align: left; max-width: 100%;">
                            <div style="background: #3498db; color: white; padding: 10px; border-radius: 5px 5px 0 0; margin-bottom: 15px;">
                                <div style="font-size: 1.2em; font-weight: bold;">${row.NombreSolicitante}</div>
                                <div style="font-size: 0.9em;">${getStatusRequests(row.status)}</div>
                            </div>
                            
                            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 15px;">
                                <div style="background: #f8f9fa; padding: 10px; border-radius: 5px;">
                                    <div style="font-size: 0.8em; color: #7f8c8d;">FECHA REGISTRO</div>
                                    <div style="font-weight: bold;">${sqlDateFormat(row.FechaCreacion)}</div>
                                </div>
                                ${row.status !== 1 ? `
                                <div style="background: #f8f9fa; padding: 10px; border-radius: 5px;">
                                    <div style="font-size: 0.8em; color: #7f8c8d;">FECHA REVISIÓN</div>
                                    <div style="font-weight: bold;">${sqlDateFormat(row.FechaRevision) || 'Pendiente'}</div>
                                </div>
                                ` : ''}
                            </div>
                            
                            ${row.status !== 1 ? `
                            <div style="background: #f8f9fa; padding: 10px; border-radius: 5px; margin-bottom: 15px;">
                                <div style="font-size: 0.8em; color: #7f8c8d;">REVISADO POR</div>
                                <div style="font-weight: bold;">${row.NombreUsuarioRevision || 'No revisado'}</div>
                            </div>
                            ` : ''}
                            ${row.Comentarios ? `
                                <div style="background: #f8f9fa; padding: 10px; border-radius: 5px;">
                                    <div style="font-size: 0.8em; color: #7f8c8d;">COMENTARIOS</div>
                                    <div style="font-weight: bold;">${row.Comentarios || ''}</div>
                                </div>
                             ` : ''}
                            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 15px;">
                             ${row.NombreEstafeta ? `   
                            <div style="background: #f8f9fa; padding: 10px; border-radius: 5px;">
                                    <div style="font-size: 0.8em; color: #7f8c8d;">ESTAFETA</div>
                                    <div style="font-weight: bold;">${row.NombreEstafeta || ''}</div>
                                </div>
                             ` : ''}
                            ${row.NombreCaja ? `
                                <div style="background: #f8f9fa; padding: 10px; border-radius: 5px;">
                                    <div style="font-size: 0.8em; color: #7f8c8d;">CAJA</div>
                                    <div style="font-weight: bold;">${row.NombreCaja || ''}</div>
                                </div>
                            ` : ''}
                            </div> 
                            <div style="background: #e8f5e9; padding: 15px; border-radius: 5px; text-align: center;">
                                <div style="font-size: 0.9em; color: #27ae60;">SALDO INGRESADO</div>
                                <div style="font-size: 1.5em; font-weight: bold; color: #27ae60;">${formatCurrency(row.SaldoIngresado)}</div>
                            </div>
                        </div>
                    `,
                    icon: "info",
                    confirmButtonText: "Cerrar",
                    confirmButtonColor: "#3498db",
                    width: "600px",
                    customClass: {
                        popup: 'custom-swal-popup',
                        confirmButton: "custom-confirm-button",
                        cancelButton: "custom-cancel-button",
                        denyButton: "custom-confirm-button",
                    }
               
                });
            },
        },
    ]);

    const formatTime = (date) => {
    
        if (!(date instanceof Date) || isNaN(date)) {
            return null; 
        }
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const handleOnSearch = async (data) => {
        const dataToSend = {
            ...data,
            IdSucursal: officeSelected ?? null,
            IdEstatus: statusSelected ?? null,
            IdSolicitante: clientSelected ?? null,
            IdCaja: cashBoxSelected ?? null,
            IdTipoSolicitud: typeSelected ? String(typeSelected) : null,
            FechaCreacionInicio: startCreationDate ? startCreationDate : null,
            FechaCreacionFin: endCreationDate ? endCreationDate: null,
            FechaRevisionInicio: startDeliveryDate ? startDeliveryDate : null,
            FechaRevisionFin: endDeliveryDate ? endDeliveryDate : null,
            HoraCreacionInicio: startCreationTime ? formatTime(startCreationTime) : null,
            HoraCreacionFin: endCreationTime ? formatTime(endCreationTime) : null,
            HoraRevisionInicio: startAprobationTime ? formatTime(startAprobationTime) : null,
            HoraRevisionFin: endAprobationTime ? formatTime(endAprobationTime) : null,
        };

        if (startCreationTime && isNaN(startCreationTime.getTime())) {
            NotifyC.error("Hora de creación no válida.", { duration: 4000 });
            return;
        }
        if (endCreationTime && isNaN(endCreationTime.getTime())) {
            NotifyC.error("Hora de fin de creación no válida.", { duration: 4000 });
            return;
        }
        if (startAprobationTime && isNaN(startAprobationTime.getTime())) {
            NotifyC.error("Hora de aprobación no válida.", { duration: 4000 });
            return;
        }
        if (endAprobationTime && isNaN(endAprobationTime.getTime())) {
            NotifyC.error("Hora de fin de aprobación no válida.", { duration: 4000 });
            return;
        }
    
        const hasAnyFieldFilled = Object.values(dataToSend).some(value => value);
        if (!hasAnyFieldFilled) {
            NotifyC.error("Por favor, complete al menos un campo para realizar la búsqueda.", { duration: 4000 });
            return;
        }
    
        setIsLoading(true);
        setIsLoadingTable(true);
        try {
            const abortController = new AbortController();
            const response = await searchRequests(abortController.signal, dataToSend);

            if (response?.code === 200) {
                setSearchedRequests(response?.payload);
                NotifyC.success("Búsqueda exitosa", { duration: 4000 });
              
            } else {
                NotifyC.error("No se encontraron resultados para la búsqueda.", { duration: 4000 });
                setSearchedRequests([]);
            }
        } catch (error) {
            NotifyC.error("Error al buscar solicitudes", { duration: 4000 });
        } finally {
            setIsLoading(false);
            setIsLoadingTable(false);
        }
    };

    const handleGetAllRequests = async () => {
        const abortController = new AbortController();
        const response = await getAllRequests(abortController.signal);
      
        if (response?.code === 200) {
            setAllRequests(response.payload);
            setIsLoadingTable(false);
        } else {
            NotifyC.error("No se encontraron solicitudes.", { duration: 6000 });
            setAllRequests([]);
            setIsLoadingTable(false);
        }
    };

    const handleSelect = (nameInput, value) => {
        if (nameInput === "IdSucursal") {
            setOfficeSelected(value);
        }
        if (nameInput === "IdEstatus") {
            setStatusSelected(value);
        }
        if (nameInput === "IdCaja") {
            setCashBoxSelected(value);
        }
        if (nameInput === "IdCliente") {
            setClientSelected(value);
        }
        if (nameInput === "IdTipoSolicitud") {
            setTypeSelected(value);
        }
    };

    const handleGetListOffices = async () => {
        const abortController = new AbortController();
        const response = await getListOffices(abortController.signal);
        if (response.length > 0) {
          
                setListOffice(response);
         
        } else {
            NotifyC.error("No se encontraron estafetas.", { duration: 6000 });
            setListOffice([]);
        }
    };

    const handleGetListRequestsStatus = async () => {
        const abortController = new AbortController();
        const response = await getListRequestsStatus(abortController.signal);
        if (response.length > 0) {
            setListStatus(response);
        } else {
            NotifyC.error("No se encontraron estados de solicitudes.", { duration: 6000 });
            setListStatus([]);
        }
    };

    const handleGetListClients = async () => {
        const abortController = new AbortController();
        try {
            const response = await getListClientByRole(abortController.signal);
            if (response.length > 0) {
                setListClients(response);
            } else {
                NotifyC.error("No se encontraron usuarios.", { duration: 6000 });
                setListClients([]);
            }
        } catch (error) {
            NotifyC.error("Error al obtener la lista de usuarios.", { duration: 6000 });
            setListClients([]);
        }
    };

    const handleGetListCashBoxes = async () => {
        const abortController = new AbortController();
        const response = await getCashBoxStatus(abortController.signal);
        if (response?.cajas?.length > 0){
            setListCashBox(response.cajas);
        }
    };

    const handleGetListTypes = async () => {
        const abortController = new AbortController();
        const response = await getListTypes(abortController.signal);
        if (response.length > 0) {
            if (user.roleId === 5) {
                const filteredTypes = response.filter(type => type.value !== 2);
                setListTypes(filteredTypes);
            }
            else {
                setListTypes(response);
            }
        } else {
            NotifyC.error("No se encontraron tipos de solicitudes.", { duration: 6000 });
            setListTypes([]);
        }
    };

    const handleErrorMessage = (field) => {
        switch (field) {
            case "BALANCE_NOT_ENOUGH":
                NotifyC.error("Saldo insuficiente en la caja para realizar esta acción.", { duration: 4000 });
                break;
            case "BALANCE_IN_OFFICE_NOT_ENOUGH":
                NotifyC.error("Saldo insuficiente en la estafeta para realizar esta acción.", { duration: 4000 });
                break;
            case 'REQUEST_ALREADY_PROCESSED':
                NotifyC.error("La solicitud ya fue procesada.", { duration: 5000 });
                break;
            case 'CASHBOX_OPEN_CANNOT_PERFORM_ACTION':
                NotifyC.error("No se puede procesar la solicitud si la caja se encuentra abierta", { duration: 5000 });
                break;
            case 'NO_ADD_MONEY_FOUND':
                NotifyC.error("La ultima acción de la caja no fue un ingreso de dinero. Cancelar la solicitud.", { duration: 5000 });
                break;
            case 'AMOUNT_NOT_MATCH':
                NotifyC.error("El saldo a anular no coincide con el ultimo monto agregado. Cancelar la solicitud.", { duration: 5000 });
                break;
            case 'CASH_ALREADY_USED_OR_MODIFIED':
                NotifyC.error("El saldo ingresado a anular ya fue utilizado o modificado. Cancelar la solicitud.", { duration: 5000 });
                break;
            case 'UNAUTHORIZED_APPROVAL_FOR_THIS_REQUEST_TYPE':
                NotifyC.error("No tienes permisos para aprobar esta solicitud.", { duration: 5000 });
                break;
            case 'CASH_WITHDRAWAL_ALREADY_MADE':
                NotifyC.error("La anulación de la solicitud ya fue realizada.", { duration: 5000 });
                break;
            case 'UPDATE_OFFICE_FAILED':
                NotifyC.error("Error al actualizar la estafeta, intentelo de nuevo.", { duration: 5000 });
                break;
            case 'UPDATE_CASHBOX_FAILED':
                NotifyC.error("Error al actualizar la caja, intentelo de nuevo.", { duration: 5000 });
                break;
            case 'CASHBOX_NOT_ACTIVE':
                NotifyC.error("La caja se encuentra desactivada. Por favor, contacta al administrador para activar la caja.", { duration: 5000 });
                break;
            case 'OFFICE_NOT_ACTIVE':
                NotifyC.error("La estafeta se encuentra desactivada. Por favor, contacta al administrador para activar la estafeta.", { duration: 5000 });
                break;
            default:
                NotifyC.error("Error al realizar la acción, intentelo de nuevo.", { duration: 4000 });
                break;  
        }
    };

    const handleConfirmAction = async (action, data, newSaldo) => {
     if (newSaldo) {
            newSaldo = parseFloat(newSaldo.replace(/[^0-9.-]+/g, ""));
        }
      const dataToSend = {
        IdSolicitud: data.IdSolicitud,
        IdEstatusAccion: action,
        SaldoFinal: newSaldo ?? data.SaldoIngresado,
        IdCaja: data.IdCaja ?? null,
      };

      try {
        const abortController = new AbortController();
        const response = await manageRequest(abortController.signal, dataToSend);
        if (response?.code === 200) {
          NotifyC.success("Acción realizada con éxito", { duration: 4000 });
          handleGetAllRequests();
        } else {
          handleErrorMessage(response?.message);
        }
      }
      catch (error) {
        NotifyC.error("Error al realizar la acción", { duration: 4000 });
      }
    };

    const handleReloadClick = async () => {
        setIsRotating(true);
        setIsLoadingTable(true);
        await handleGetAllRequests();
        setIsRotating(false);
        setIsLoadingTable(false);
        NotifyC.success("Recargando solicitudes", { duration: 4000 });
    };


    const resetForm = () => {
        reset();
        setOfficeSelected("");
        setStatusSelected("");
        setCashBoxSelected("");
        setClientSelected("");
        setCreationDateRange([null, null]);
        setDeliveryDateRange([null, null]);
        setTimeCreation([]);
        setTimeAprobation([]);
        setSearchedRequests([]);
        setTypeSelected("");
        handleReloadClick();
    };

  const columns = useMemo(() => [
        { Header: "No. Solicitud",accessor: "IdSolicitud", width: 50,Cell: ({ cell }) => <span>{cell.value}</span>,},
        { Header: "Tipo de solicitud",accessor: "IdTipoSolicitud", width: 50,Cell: ({ cell }) => <span>{getTypeRequestName(cell.value)}</span>,},
        { Header: "Tipo de movimiento", accessor: "Accion", width: 50,
            Cell: ({ cell }) => {
                const actionValue = cell.value; 
                let color = ""; 
                switch (actionValue) {
                    case 3: 
                        color = "#28a746"; 
                        break;
                    case 4: 
                        color = "#007bff"; 
                        break;
                    case 5: 
                        color = "#dc3545"; 
                        break;
                    case 6:
                        color = "#ffa600";
                        break;
                    default:
                        color = "#f8f9fa"; 
                }  
                return (
                    <span
                        style={{
                            color,
                            padding: "5px 10px",
                            borderRadius: "5px",
                            display: "inline-block",
                            textAlign: "center",
                            minWidth: "80px",
                            fontSize: "15px",
                            fontWeight: "bold",
                        }}
                    >
                        {getActionName(actionValue)} 
                    </span>
                );
            },
        },
        { Header: "Solicitante",accessor: "NombreSolicitante", width: 50,Cell: ({ cell }) => <span>{cell.value}</span>,},
        { Header: "Estafeta",accessor: "NombreEstafeta", width: 50,Cell: ({ cell }) => <span>{cell.value ? cell.value : '-'}</span>,},
        { Header: "Caja",accessor: "NombreCaja", width: 50,Cell: ({ cell }) => <span>{cell.value ? cell.value : '-'}</span>,},
        { Header: "Saldo Ingresado", accessor: "SaldoIngresado", width: 100, Cell: ({ cell }) => <span>{formatCurrency(cell.value)}</span>,},
               { Header: "Estado", accessor: "status", width: 100,
            Cell: ({ cell }) => {
                const statusValue = cell.value; 
                let backgroundColor = "";
                switch (statusValue) {
                    case 1:
                        backgroundColor = "#FFD700"; 
                        break;
                    case 2: 
                        backgroundColor = "#28a745"; 
                        break;
                    case 3: 
                        backgroundColor = "#dc3545"; 
                        break;
                    case 4: 
                        backgroundColor = "#6c757d"; 
                        break;
                    default:
                        backgroundColor = "#f8f9fa"; 
                }
        
                return (
                    <span
                        style={{
                            backgroundColor,
                            color: "white", 
                            padding: "5px 10px",
                            borderRadius: "5px",
                            display: "inline-block",
                            textAlign: "center",
                            minWidth: "80px",
                            fontWeight: "bold",
                            fontSize: "15px",
                        }}
                    >
                        {getStatusRequests(statusValue)} 
                    </span>
                );
            },
        },
            { Header: "Acciones", accessor: "actions", width: 100,
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center">
                        {[3, 5, 9].includes(user.roleId) && row.original.status === 1
                            ? actionButtons.map((button, index) => (
                                <button
                                    key={index}
                                    className="btn btn-icon custom-hover-button"
                                    onClick={() => button.action(row.original)}
                                    title={button.label}
                                >
                                    {button.icon}
                                </button>
                            ))
                            : actionButtons
                                .filter((button) => button.label === "Detalles")
                                .map((button, index) => (
                                    <button
                                        key={index}
                                        className="btn btn-icon custom-hover-button"
                                        onClick={() => button.action(row.original)}
                                        title={button.label}
                                    >
                                        {button.icon}
                                    </button>
                                ))
                        }
                    </div>
                ),
            },
    ], []);



  const exportColumns = useMemo(() => [
        { Header: "No. Solicitud", accessor: "IdSolicitud" },
        { Header: "Tipo de solicitud", accessor: "IdTipoSolicitud", Cell: ({ value }) => getTypeRequestName(value) },
        { Header: "Tipo de movimiento", accessor: "Accion", Cell: ({ value }) => getActionName(value) },
        { Header: 'Comentarios', accessor: 'Comentarios', Cell: ({ value }) => value ? value : '-' },
        { Header: "Fecha de registro", accessor: "FechaCreacion", Cell: ({ value }) => value ? sqlDateFormat(value, false, true).split('-')[0] : "-" },
        { Header: "Hora de registro", accessor: "FechaCreacion", Cell: ({ value }) => value ? sqlDateFormat(value, false, true).split('-')[1] : "-" },
        { Header: "Fecha de revisión", accessor: "FechaRevision", Cell: ({ value, row }) => row.original.status !== 1 && value ? sqlDateFormat(value, true, true).split('-')[0] : "-" },
        { Header: "Hora de revisión", accessor: "FechaRevision", Cell: ({ value, row }) => row.original.status !== 1 && value ? value : "-" },
        { Header: "Revisado por", accessor: "NombreUsuarioRevision", Cell: ({ value, row }) => row.original.status !== 1 && value ? value : "-"  },
        { Header: "Solicitante", accessor: "NombreSolicitante", Cell: ({ value }) => value ? value : "-"  },
        { Header: "Estafeta", accessor: "NombreEstafeta", Cell: ({ value }) => value ? value : "-"  },
        { Header: "Caja", accessor: "NombreCaja", Cell: ({ value }) => value ? value : "-"  },
        { Header: "Saldo Ingresado", accessor: "SaldoIngresado", Cell: ({ value }) => formatCurrency(value) },
        { Header: "Estado", accessor: "status", Cell: ({ value }) => getStatusRequests(value) }
    ], []);

  const renderInput = (field, label, required, type, Icon, placeholder) => (
      <div className="col-12 col-md-4 input-group text-left mb-3">
          <div className="input-group-prepend d-flex align-items-center">
              <span className="input-group-text text-bold input-label" style={{
              backgroundColor: "#FBD825",
              color: "black",
          }}>
                  {Icon && <Icon className="mr-2" size={18} />} {label}
              </span>
          </div>
          <input
              type={type ?? "text"}
              className="form-control input-field"
              name={field}
              ref={register()}
              required={required}
              placeholder={placeholder}
          />
          {errors[field] && (
              <span className="text-danger">{errors[field].message}</span>
          )}
      </div>
  );

  const renderDateTimePicker = (field, label, name, Icon, placeholder, time, setTime, start, end, setDateRange) => (
      <div className="col-12 col-md-4 input-group text-left mb-3 customDatePickerWidth">
          <div className="input-group-prepend d-flex align-items-center">
              <span className="input-group-text text-bold input-label" style={{
              backgroundColor: "#FBD825",
              color: "black",
          }}>
                  {Icon && <Icon className="mr-2" size={18} />} {label}
              </span>
          </div>
              {field === "date" && (
              <DatePicker
                  type="text"
                  selectsRange={true}
                  startDate={start}
                  endDate={end}
                  onChange={(update) => { setDateRange(update);}}
                  name={name}
                  isClearable={true}
                  placeholderText={placeholder}
                  className="form-control input-field"
                  dateFormat="dd/MM/yyyy"
                  style={{ flexGrow: 1, width: "100%", minWidth: "300px" }}
              />
              )}
              {field === "time" && (
                  <CustomProvider locale={locale.value}>
                  <TimeRangePicker 
                      format="hh:mm aa"
                      showMeridiem 
                      className="input-field w-100 "
                      value={time ?? []}
                      onChange={setTime}       
                      placeholder={placeholder}
                      cleanable={true}
                      style={{ fontSize: "20px" }}
                  />
                  </CustomProvider>
              )
              }
          {errors[field] && (
              <span className="text-danger">{errors[field].message}</span>
          )}
      </div>
  );


  const renderSelect = (nameInput, title, options, value) => (
      <div className="col-12 col-md-4 input-group text-left mb-3">
          <div className="d-flex w-100">
              <div className="input-group-prepend d-flex align-items-center">
                  <span className="input-group-text text-bold input-label" style={{
              backgroundColor: "#FBD825",
              color: "black",
              borderRadius: "6px 0 0 6px",
          }}><RiUserReceivedLine className="mr-2" size={18} /> {title}</span>
          </div>
              <SelectSearch
                  options={options}
                  nameInput={nameInput}
                  setValue={handleSelect}
                  value={value}
              />
          </div>
      </div>
  );

  
  const renderOriginSelectCashBox = (nameInput, title) => {
      const options = listCashBox.map(cashBox => ({
          value: cashBox.IdCaja || "",
          label: cashBox.NombreCaja || ""
      }));
      return (
          <div className="col-12 col-md-4 input-group text-left mb-3" style={{  width: "100%" }}>
              <div className="d-flex w-100">
                  <div className="input-group-prepend d-flex align-items-center">
                      <span className="input-group-text text-bold input-label" style={{ backgroundColor: "#FBD825", color: "black", borderRadius: "6px 0 0 6px" }}>
                          <BsBuilding className="mr-2" size={18} /> {title}
                      </span>
                  </div>
                  <SelectSearch 
                      options={options} 
                      nameInput={nameInput} 
                      setValue={handleSelect} 
                      value={cashBoxSelected} 
                  />
              </div>
          </div>
      );
  };

    useEffect(() => {
        handleGetListCashBoxes();
        handleGetListOffices();
        handleGetListRequestsStatus();
        handleReloadClick();
        handleGetListClients();
        handleGetListTypes();
    }
    , []);

    return (<> 
    <div className="dashboardCard justify-left" style={{ color: "black" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="d-flex align-items-center" style={{ gap: 15 }}>
                <FaClock size={25} />
                <h5 className="mb-0">Gestión de Solicitudes</h5>
            </div>
             <FaSyncAlt
                size={20}
                style={{ cursor: "pointer", animation: isRotating ? "spin 2s linear infinite" : "none" }}
                onClick={() => handleReloadClick()}
            />   
        </div>
    </div>
    <div className="dashboardCard">
      <div className="d-flex">
      <p style={{color: "#6C757D", fontSize: "16px", marginBottom: "20px", textAlign: "start",
        }}>Ingrese la información de la solicitud que desea buscar:</p>
      </div>
  
        <form onSubmit={handleSubmit(handleOnSearch)}>
        <div className="row">
            <div className="col-12 col-md-12 input-group text-left p-0">
                {renderSelect("IdCliente", "Solicitantes", listClients, clientSelected)}
                {renderDateTimePicker("date", "Fecha de Registro", "FechaCreacion", BsCalendar2Check, "Seleccione la fecha de registro", null, null, startCreationDate, endCreationDate, setCreationDateRange)}
                {renderDateTimePicker("date", "Fecha de Revisión", "FechaRevision", BsCalendar2Check, "Seleccione la fecha de revisión", null, null, startDeliveryDate, endDeliveryDate, setDeliveryDateRange)}
           
           </div>
             <div className="col-12 col-md-12 input-group text-left p-0 ">
                {renderInput("IdSolicitud", "Nro. Solicitud", false, "number", BsSearch, "Ingrese el ID de la solicitud")}
                {renderSelect("IdEstatus", "Estado", listStatus, statusSelected)}
                {renderDateTimePicker("time", "Hora de Registro", "HoraCreacion", BsClock, "Seleccione la hora de registro", startCreationTime, endCreationTime, setTimeCreation)}
              
            </div>
         
            <div className="col-12 col-md-12 input-group text-left p-0">
                {renderDateTimePicker("time", "Hora de Revisión", "HoraRevision", BsClock, "Seleccione la hora de revisión", startAprobationTime, endAprobationTime, setTimeAprobation)}
                {(user.roleId === 8 || user.roleId === 9) && renderSelect("IdSucursal", "Estafeta", listOffice, officeSelected)}
                {(user.roleId === 8 || user.roleId === 9)  && renderOriginSelectCashBox("IdCaja", "Caja")}
                {(user.roleId === 5) && renderSelect("IdTipoSolicitud", "Tipo de Solicitud", listTypes, typeSelected)} 
                {(user.roleId === 5) && renderSelect("IdSucursal", "Estafeta", listOffice, officeSelected)}
                {(user.roleId === 3) && renderOriginSelectCashBox("IdCaja", "Caja")}
           </div>
    
            <div className="col-12 col-md-12 input-group text-left p-0">
                {(user.roleId === 8 || user.roleId === 9)  && renderSelect("IdTipoSolicitud", "Tipo de Solicitud", listTypes, typeSelected)} 
            
            </div>
        </div>
            <div className="d-flex justify-content-center mt-3" style={{gap:"12px"}}>
                {isLoading ? (
                        <button type="submit" className="btn btn-blue" disabled><Spinner type={1} size={15} /> Buscar</button>
                ) : (
                    <button type="submit" className="btn btn-blue"><BsSearch /> Buscar</button>
                )}
                <button type="reset" className="btn btn-secondary" onClick={resetForm}><TbZoomReset size={20}/> Reiniciar</button>
            </div>
            </form>
    </div>

        {isLoadingTable || isLoading  ? (
            <div className="dashboardCard mt-3">
                <Spinner type={1} size={30} />
            </div>
        ) : (
            (searchedRequests && searchedRequests.length > 0) ? (
                <div className="dashboardCard mt-3">
                    <DataTable 
                        columns={columns}
                        data={searchedRequests}
                        exportExcel
                        exportPdf
                        exportableColumns={exportColumns}
                    />
                </div>
            ) : (allRequests && allRequests.length > 0) ? (
                <div className="dashboardCard mt-3">
                    <DataTable 
                        columns={columns}
                        data={allRequests}
                        exportExcel
                        exportPdf
                        exportableColumns={exportColumns}
                    />
                </div>
            ) : (
                <div className="dashboardCard mt-3">
                    <p className="text-center">No se encontraron solicitudes.</p>
                </div>
            )
        )}
          
    </>);
}

export default Solicitudes;